module.exports = __webpack_public_path__ + "static/regulamin-swiadczenia-uslug-ladowania-PKN-ORLEN-2024-a213f9df007068256e1773e2ac86ad03.pdf";